var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Flow',_vm._b({},'Flow',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }